import React, { useEffect } from 'react';
//inview
import { useInView } from 'react-intersection-observer';
//hooks
import useReservHook from 'src/webapp/hooks/reserv/reserv.hook';
//styles
import styles from 'src/asset/scss/styles/userPartnerCalcDetail.module.scss';
//CompWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//Comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Info from './Info';//기본정보
import Search from './reservList/Search';
import List from './reservList/List';
import InViewData from 'src/webapp/views/component/data/InViewData';//데이터로드확인

export default function PartnerCalcDetailList() {
    //hook
    const {pageRef//무한로딩페이지DOM
        , searchRef//검색어DOM
        , scrollRef//elementScroll관리Ref
        , memberReservList//예약리스트데이터
        , memberReservListAPI//예약리스트API
    } = useReservHook();
    //useEffect
    useEffect(() => {
        memberReservListAPI(0, 2);//예약리스트API
    }, []);
    //infinityObserver
    const [inViewRef, inView] = useInView({ threshold: .5 });
    useEffect(() => {
        if (inView && (pageRef.current != null)) { memberReservListAPI(1, 2); }//예약리스트API
    }, [inView]);

    return (
        <Section>
            <Menu />{/* 메뉴 */}
            <Container>
                <FixedPanel>
                    <Titlebar title={`정산 내역`} dept={[{ label: '정산 관리' }, { label: '정산 내역' }, { label: '정산 내역 상세' }]} />{/* 상단타이틀 */}
                </FixedPanel>
                <FixedPanel>
                    <Info />
                </FixedPanel>
                <FlickPanel>
                    <Element tag={`div`} className={["fullHeight", styles.flickArea].join(" ")} propRef={el => (scrollRef.current = el)}>
                        <Search searchRef={searchRef} cnt={memberReservList[0]?.TOT_CNT ?? 0} onSearch={memberReservListAPI} />
                        <List ref={searchRef} list={memberReservList} />
                        {memberReservList?.length > 0 && pageRef.current != null ? <div ref={inViewRef}><InViewData inView={true} /></div>
                        : memberReservList?.length > 0 && pageRef.current === null ? <InViewData readAll={true} />
                        : null}
                    </Element>
                </FlickPanel>
            </Container>
        </Section>
    );
}